// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"09fc2eb5","977":"7c954164"}[chunkId] + ".chunk.js";
};